import { FC } from "react";
import { Flex, Spacer } from "@smile2impress/components/relaunch";

type MenuPlaceholderRef = React.MutableRefObject<HTMLDivElement | null>;

export type HeaderContentBarProps = {
    isCentered: boolean;
    logo: React.ReactNode;
    rightSlot: React.ReactNode;
    menuPlaceholderRef: MenuPlaceholderRef;
};

export const HeaderContentBar: FC<HeaderContentBarProps> = ({
    isCentered,
    logo,
    rightSlot,
    menuPlaceholderRef,
}) => (
    <Flex
        flexDirection="row"
        alignItems="center"
        h="100%"
        py={[1, 1, 0]}
        mx={[0, 0, 4]}
        justifyContent={isCentered ? "center" : "flex-start"}
        position="relative"
    >
        {isCentered && <Spacer flex={1} />}
        {logo}
        <Spacer ref={menuPlaceholderRef} flex={isCentered ? 1 : undefined} />
        <Flex
            display={["block", "block", "none"]}
            position={isCentered ? "absolute" : undefined}
            right={isCentered ? [2, 2, 4] : undefined}
        >
            {rightSlot}
        </Flex>
    </Flex>
);
